import { render, staticRenderFns } from "./HackSCHS.vue?vue&type=template&id=566caa15&scoped=true&"
import script from "./HackSCHS.vue?vue&type=script&lang=js&"
export * from "./HackSCHS.vue?vue&type=script&lang=js&"
import style0 from "./HackSCHS.vue?vue&type=style&index=0&id=566caa15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566caa15",
  null
  
)

export default component.exports